"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Svg24FoodLine = function Svg24FoodLine(_ref) {
  var fill = _ref.fill,
      useDefaultColors = _ref.useDefaultColors,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["fill", "useDefaultColors", "title"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: useDefaultColors ? 'none' : fill,
    "aria-hidden": title === null || typeof title !== 'string' || title.length === 0
  }, props), _react.default.createElement("title", null, title), _react.default.createElement("path", {
    d: "M5 4a1 1 0 0 1 1 1v4.888a2 2 0 0 0 4 0V5a1 1 0 1 1 2 0v4.888a4 4 0 0 1-2.5 3.709V20a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-6.403A4 4 0 0 1 4 9.888V5a1 1 0 0 1 1-1z",
    fill: useDefaultColors ? '#191919' : fill
  }), _react.default.createElement("path", {
    d: "M8 4a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0V5a1 1 0 0 1 1-1z",
    fill: useDefaultColors ? '#191919' : fill
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.013 3c-1.162-.023-2.42.265-3.406 1.093C14.59 4.947 14 6.261 14 8v6.002c0 1.106.898 1.998 2 1.998h1v4a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V4a1 1 0 0 0-.987-1zM18 5.095c-.43.1-.807.277-1.107.53C16.41 6.03 16 6.739 16 8v6h2V5.095z",
    fill: useDefaultColors ? '#191919' : fill
  }));
};

Svg24FoodLine.propTypes = {
  title: _propTypes.default.string,
  fill: _propTypes.default.string,
  useDefaultColors: _propTypes.default.bool
};
var _default = Svg24FoodLine;
exports.default = _default;